import {
  useAdvanceTableConfigContext,
  useAdvanceTableDataBrowseContext,
} from '../../../context';

export function useTableHeight() {
  const { config } = useAdvanceTableConfigContext();
  const { browseData } = useAdvanceTableDataBrowseContext();

  const { data, isLoading } = browseData;

  const notFound = !isLoading && !data?.content?.length && !data?.top?.length;

  const height = !notFound && config.maxHeight ? config.maxHeight : '100%';
  return height;
}
